import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Sparkles, X } from 'lucide-react';

const PLAN_DETAILS = {
    student: {
        name: "Student",
        price: "¥480",
        description: "学生向けのお手頃プラン",
        benefits: [
            "全ての診断が無制限",
            "40法則（20個まで）",
            "学習計画作成",
            "リマインダー設定"
        ]
    },
    standard: {
        name: "Standard",
        price: "¥980",
        description: "個人の成長を加速させるスタンダードプラン",
        benefits: [
            "Studentプランの全機能",
            "40法則（全閲覧）",
            "成長パターン分析",
            "成長予測 AI"
        ]
    },
    business: {
        name: "Business",
        price: "¥4,980",
        description: "組織全体のパフォーマンスを最大化",
        benefits: [
            "Standardプランの全機能",
            "チーム機能（メンバー管理）",
            "組織分析ダッシュボード",
            "1on1支援AI",
            "優先サポート"
        ]
    }
};

export function UpgradeModal({
    isOpen,
    onClose,
    featureName = "この機能",
    recommendedPlan = "standard"
}) {
    if (!isOpen) return null;

    const planInfo = PLAN_DETAILS[recommendedPlan] || PLAN_DETAILS['standard'];

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            {/* Overlay */}
            <div
                className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 z-10 p-2 bg-black/5 rounded-full hover:bg-black/10 transition-colors"
                >
                    <X className="w-5 h-5 text-gray-500" />
                </button>

                {/* Header Section */}
                <div className="bg-gradient-to-br from-indigo-600 to-purple-700 p-8 text-center text-white relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

                    <div className="flex justify-center mb-4 text-yellow-300">
                        <Sparkles className="w-8 h-8" />
                    </div>
                    <h2 className="text-2xl font-bold mb-2">
                        {featureName}を<br />アンロックしましょう
                    </h2>
                    <p className="text-indigo-100 text-sm">
                        {planInfo.name}プランで、制限なく利用可能です。
                    </p>
                </div>

                {/* Content Section */}
                <div className="p-8 space-y-6">
                    <div className="flex items-baseline justify-center space-x-1 border-b border-gray-100 pb-6">
                        <span className="text-4xl font-extrabold text-gray-900">{planInfo.price}</span>
                        <span className="text-gray-500 font-medium">/月</span>
                    </div>

                    <div className="space-y-4">
                        <p className="text-sm font-semibold text-gray-700 uppercase tracking-wider">プランに含まれるもの:</p>
                        <ul className="space-y-3">
                            {planInfo.benefits.map((benefit, i) => (
                                <li key={i} className="flex items-start text-sm text-gray-600">
                                    <div className="mr-3 mt-0.5 p-0.5 bg-green-100 rounded-full text-green-600">
                                        <Check className="w-3 h-3 stroke-[3]" />
                                    </div>
                                    {benefit}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="space-y-3 pt-4">
                        <Link
                            to={`/subscription?plan=${recommendedPlan}`}
                            className="block w-full text-center py-4 px-6 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl shadow-lg shadow-indigo-200 transition-all hover:-translate-y-0.5"
                        >
                            {planInfo.name}プランを始める
                        </Link>
                        <button
                            onClick={onClose}
                            className="block w-full py-3 text-sm text-gray-400 hover:text-gray-600 font-medium transition-colors"
                        >
                            今はまだいいです
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
